import { createSlice } from '@reduxjs/toolkit';
import { ImageModel, useAppSelector } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchPlacesBlockThunk } from 'shared/lib';
import { Place, placeSchema } from 'entities/place';
import BaseError from '../../../utils/base-error';

export type PlacesBlockState = {
    loaded: boolean
    errors: BaseError[]
    image?: ImageModel
    places: Place[]
}

const initialState: PlacesBlockState = {
    loaded: false,
    errors: [],
    places: [],
};

// eslint-disable-next-line import/prefer-default-export
export const placesBlockSlice = createSlice({
    name: 'placesBlockSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchPlacesBlockThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        const { data } = response.data;

                        state.places = data.places?.map((dto) => (
                            placeSchema.parse(dto)
                        )) || [];

                        if (response.data.data.image) {
                            state.image = {
                                url: createStrapiMediaUrl(response.data.data.image.url),
                            };
                        }
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
    },
});

export const usePlacesBlockState = () => useAppSelector((store) => store.placesBlock);
